export default "__VITE_ASSET__bed808a7__"